var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'MainGroupbuyingsList'
      }
    }
  }, [_vm._v("總公司團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("檢視總公司門市庫存品團購")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-9"
  }, [_c('h4', {
    staticClass: "mb-2 font-weight-bold"
  }, [_vm._v(" 檢視總公司門市庫存品團購 ")]), _c('section', {
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "h5"
  }, [_vm._v("Step 1: 請選擇分店")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "團購分店",
      "label-for": "input-1"
    }
  }, [_vm.groupbuying.branches ? _c('b-card', {
    staticClass: "mb-1",
    attrs: {
      "no-body": ""
    }
  }, [_c('b-card-header', {
    staticClass: "p-0",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.branchTable",
      modifiers: {
        "branchTable": true
      }
    }],
    attrs: {
      "block": "",
      "variant": "secondary"
    }
  }, [_vm._v("共：" + _vm._s(_vm.groupbuying.branches.length) + " 筆")])], 1), _c('b-collapse', {
    attrs: {
      "id": "branchTable",
      "accordion": "my-accordion",
      "role": "tabpanel"
    }
  }, [_c('b-card-body', {
    staticClass: "branch_table_card_body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("門市")]), _c('th', [_vm._v("開始時間")]), _c('th', [_vm._v("結束時間")]), _c('th', [_vm._v("庫存")]), _c('th', [_vm._v("每人最高購買數")]), _c('th', [_vm._v("每人最低購買數")]), _c('th', [_vm._v("下單數量遞增數")]), _c('th', [_vm._v("狀態")])])]), _c('tbody', _vm._l(_vm.groupbuying.branches, function (branch) {
    return _c('tr', {
      key: branch.id
    }, [_c('td', [_vm._v(_vm._s(branch.branch_code) + " " + _vm._s(branch.name))]), _c('td', [_vm._v(_vm._s(branch.pivot.start_at))]), _c('td', [_vm._v(_vm._s(branch.pivot.end_at))]), _c('td', [_vm._v(_vm._s(branch.pivot.total_sku_quantity))]), _c('td', [_vm._v(_vm._s(branch.pivot.once_max_quantity))]), _c('td', [_vm._v(_vm._s(branch.pivot.once_quantity))]), _c('td', [_vm._v(_vm._s(branch.pivot.once_increase_quantity))]), _c('td', [branch.pivot.status === 'success' ? _c('b-badge', {
      attrs: {
        "variant": "success"
      }
    }, [_vm._v("成功")]) : branch.pivot.status === 'failed' ? _c('b-badge', {
      attrs: {
        "variant": "danger"
      }
    }, [_vm._v(" 失敗: " + _vm._s(branch.pivot.memo) + " ")]) : _c('b-badge', {
      attrs: {
        "variant": "secondary"
      }
    }, [_vm._v("未開團")])], 1)]);
  }), 0)])])], 1)], 1) : _vm._e()], 1)], 1), _c('section', {
    staticClass: "mb-8"
  }, [_c('div', {
    staticClass: "h5"
  }, [_vm._v("Step 2: 請編輯團購設定")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "content-cols": "12",
      "content-cols-lg": "7",
      "label-size": "sm",
      "label": "請輸入商品編號，輸入完畢後，請按確認"
    }
  }, [_c('div', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入商品編號",
      "disabled": true,
      "state": _vm.v$.form.product_ids.$error ? false : null
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSearchProducts.apply(null, arguments);
      }
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": true
    },
    on: {
      "click": _vm.handleSearchProducts
    }
  }, [_vm._v("確認")])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.product_ids.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('ProductViewer', {
    attrs: {
      "loading": _vm.isFetchProduct,
      "product": _vm.selectedProduct
    }
  })], 1)])], 1), _c('div', [_c('b-form-group', {
    attrs: {
      "label-cols": "7",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "庫存共",
      "label-for": "max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "max_quantity",
      "type": "number",
      "state": _vm.v$.form.max_quantity.$error ? false : null,
      "disabled": true
    },
    model: {
      value: _vm.form.max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "max_quantity", $$v);
      },
      expression: "form.max_quantity"
    }
  }), _vm._v(" 件 ")], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最高購買數",
      "label-for": "once_max_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_max_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 0 ? 0 : Math.round(value);
      },
      "state": _vm.v$.form.once_max_quantity.$error ? false : null,
      "disabled": true
    },
    model: {
      value: _vm.form.once_max_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_max_quantity", $$v);
      },
      expression: "form.once_max_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_max_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於商品總數上限 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "每人最低購買數",
      "label-for": "once_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": true,
      "state": _vm.v$.form.once_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_quantity", $$v);
      },
      expression: "form.once_quantity"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.once_quantity.less.$invalid
    }
  }, [_vm._v(" 需小於每人最高購買數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "下單數量遞增數",
      "label-for": "once_increase_quantity"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "id": "once_increase_quantity",
      "type": "number",
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      },
      "disabled": true,
      "state": _vm.v$.form.once_increase_quantity.$error ? false : null
    },
    model: {
      value: _vm.form.once_increase_quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "once_increase_quantity", $$v);
      },
      expression: "form.once_increase_quantity"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "label": "開始時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": true,
      "disabledDates": _vm.disabledDates
    },
    model: {
      value: _vm.form.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "date", $$v);
      },
      expression: "form.start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": true
    },
    model: {
      value: _vm.form.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.start_at, "time", $$v);
      },
      expression: "form.start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.time.HH.$error || !_vm.v$.form.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "截止時間",
      "content-cols": "12",
      "content-cols-lg": "6",
      "description": "*達截止時間系統將自動結團"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "Select Date",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": {
        'is-invalid': _vm.v$.form.start_at.$invalid
      },
      "disabledDates": _vm.disabledDates,
      "disabled": true
    },
    model: {
      value: _vm.form.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "date", $$v);
      },
      expression: "form.end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.start_at.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 截止時間必須大於開團時間 ")])], 1), _c('div', {
    staticClass: "ml-2 w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.form.start_at.time.HH.$error || _vm.v$.form.start_at.time.mm.$error || _vm.v$.form.start_at.date.beforeEndAt.$invalid
      }],
      "disabled": true
    },
    model: {
      value: _vm.form.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.form.end_at, "time", $$v);
      },
      expression: "form.end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.end_at.time.HH.$error || !_vm.v$.form.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "員工編號",
      "label-for": "tracking_code"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 w-100 w-lg-35",
    attrs: {
      "id": "tracking_code",
      "formatter": function formatter(value) {
        return value.length > 6 ? value.slice(0, 6) : value;
      },
      "state": _vm.v$.form.tracking_code.$error ? false : null,
      "disabled": true
    },
    model: {
      value: _vm.form.tracking_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tracking_code", $$v);
      },
      expression: "form.tracking_code"
    }
  }), _vm.v$.form.tracking_code.required.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 此欄位為必填 ")]) : _vm._e(), _vm.v$.form.tracking_code.lengthSix.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 需為6碼數字 ")]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "6",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "順序",
      "label-for": "order"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0 w-100 w-lg-35",
    attrs: {
      "id": "order",
      "type": "number",
      "disabled": true,
      "formatter": function formatter(value) {
        return value < 1 ? 1 : Math.round(value);
      }
    },
    model: {
      value: _vm.form.order,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "order", $$v);
      },
      expression: "form.order"
    }
  }), _vm.v$.form.order.required.$invalid ? _c('b-form-invalid-feedback', [_vm._v(" 此欄位為必填 ")]) : _vm._e()], 1)], 1)])])]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger",
      "disabled": _vm.isFetchGroupbuying || _vm.isSubmmiting
    },
    on: {
      "click": _vm.handleCancelGroupbuy
    }
  }, [[_vm._v("返回")]], 2)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }